import { Show, type Component } from 'solid-js';

import type { GameStore } from '../state/store';

/**
 * A red wash from the edges of the screen when the local player is hit.
 *
 * The `damage-taken` overlay from §5 of the art spec, and the only one of the two
 * that has anything to drive it — see the note beside `.overlay-fx--rage` in
 * `base.css`, which stays unused because the simulation has no such state.
 *
 * **Derived, never stored.** The store already keeps every damage number with the
 * instant it arrived and who it landed on; a separate "am I hurt" flag would be a
 * second copy of that fact, and a copy set from an event is a copy that can be
 * left on when the event that clears it is dropped. `store.hurt()` reads the same
 * list the floating numbers do.
 *
 * It carries no information the numbers do not: `aria-hidden`, no text, no
 * pointer events. Which is the point — it is peripheral vision, for the case where
 * the player is watching their cursor and a monster is behind them.
 */
export const HurtFlash: Component<{ store: GameStore }> = (props) => (
  <Show when={props.store.hurt()}>
    <div class="overlay-fx overlay-fx--hurt" data-testid="hurt-flash" aria-hidden="true" />
  </Show>
);
